import CardImageMarkers from "../../../../components/CockpitCards/CardImageMarkers";
import { vitamins } from "../../../../constants";


export default function VitaminsCard() {
  

return (

    <CardImageMarkers 
    
        image={vitamins}
        title="NUTRIENTS & VITAMINS"
        subtitle="Check balance of your daily food intake"
        markersTitle=""
        markers="Fe, Ferritin, Tansferrin,
                Transferrinsättigung, Mg,
                Vit. D3, Vit. B12

                "

    />


)
}